import { Component, Inject, OnInit } from "@angular/core";
import { TuiDialogContext } from "@taiga-ui/core";
import { ApiService } from "src/app/core/services/shared/api.service";
import { GlobalVarService } from "src/app/core/services/shared/global-var.service";
import { NotificationService } from "src/app/core/services/shared/notification.service";
import { CodehelpService } from "virtue-form";
import { POLYMORPHEUS_CONTEXT } from "@tinkoff/ng-polymorpheus";

@Component({
  selector: 'app-demo-user-intro',
  templateUrl: './demo-user-intro.component.html',
  styleUrls: ['./demo-user-intro.component.scss']
})
export class DemoUserIntroComponent implements OnInit {

  constructor(

    @Inject(POLYMORPHEUS_CONTEXT)
    private readonly context: TuiDialogContext<string>,
  ) { }

  ngOnInit(): void {
  }

  onClose()
  {

this.context.completeWith("");
  }

}
